import { DirectionsCar } from "@mui/icons-material";
import { FC } from "react";

import { MapLibreVehicleCarCircle } from "./maplibre-vehicle-car-circle";
import { MapLibreVehicleCarRoot } from "./maplibre-vehicle-car-marker.styled";

interface IMapLibreVehicleCarMarkerProps {
  fillColor: string;
  isDetour?: boolean;
}

/**
 * Fixed-size SVG circle vehicle marker for MapLibre.
 * Avoids Leaflet `.map-marker-simple-icon` HTML that MapLibre stretches into ovals.
 */
export const MapLibreVehicleCarMarker: FC<IMapLibreVehicleCarMarkerProps> = ({
  fillColor,
  isDetour = false,
}) => (
  <MapLibreVehicleCarRoot $fillColor={fillColor} $isDetour={isDetour}>
    <MapLibreVehicleCarCircle />
    <span className="maplibre-vehicle-car-icon">
      <DirectionsCar fontSize="inherit" />
    </span>
  </MapLibreVehicleCarRoot>
);
